<template>
  <SpaceWindow :title="title">
    <div class="wrapper">
      <el-tabs v-model="activate" @tab-click="trigger">
        <el-tab-pane label="今天"  name="today">
          <div class="pane-wrapper">
            <div class="body" :style="{height: height}">
              <slot :data="todayExportList" :style="{height: height}"></slot>
              <div class="empty" v-show="data.today.pageTotal === 0 && !data.today.moreFlag && !data.today.loadingFail">
                <img src="/static/img/baseComponent/byDayTemplate/no_data.png" alt="暂无访问"/>
              </div>
              <div class="fail"  v-show="data.today.loadingFail">
                <img src="/static/img/baseComponent/byDayTemplate/loading_fail.png" alt="加载失败"/>
              </div>
            </div>
            <div class="line"></div>
            <div class="footer">
              <el-button icon="el-icon-caret-left" size="mini" :disabled="data.today.pageIndex <= 1" type="primary" round @click="--data.today.pageIndex"></el-button>
              <el-button icon="el-icon-caret-right" size="mini" type="primary" round @click="nextPage"
                         :disabled="!data.today.moreFlag && data.today.pageIndex === data.today.pageTotal"
                         :loading="data.today.loadingFlag"></el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="昨天"  name="yesterday">
          <div class="pane-wrapper">
            <div class="body" :style="{height: height}">
              <slot :data="yesterdayExportList"></slot>
              <div class="empty" v-show="data.yesterday.pageTotal === 0 && !data.yesterday.moreFlag && !data.yesterday.loadingFail">
                <img src="/static/img/baseComponent/byDayTemplate/no_data.png" alt="暂无访问"/>
              </div>
              <div class="fail" v-show="data.yesterday.loadingFail">
                <img src="/static/img/baseComponent/byDayTemplate/loading_fail.png" alt="加载失败"/>
              </div>
            </div>
            <div class="line"></div>
            <div class="footer">
              <el-button icon="el-icon-caret-left" size="mini" :disabled="data.yesterday.pageIndex <= 1" type="primary" round @click="--data.yesterday.pageIndex"></el-button>
              <el-button icon="el-icon-caret-right" size="mini" type="primary" round @click="nextPage"
                         :disabled="!data.yesterday.moreFlag && data.yesterday.pageIndex === data.yesterday.pageTotal"
                         :loading="data.yesterday.loadingFlag"></el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="前天"  name="beforeYesterday">
          <div class="pane-wrapper">
            <div class="body" :style="{height: height}">
              <slot :data="beforeYesterdayExportList"></slot>
              <div class="empty" v-show="data.beforeYesterday.pageTotal === 0 && !data.beforeYesterday.moreFlag && !data.beforeYesterday.loadingFail">
                <img src="/static/img/baseComponent/byDayTemplate/no_data.png" alt="暂无访问"/>
              </div>
              <div class="fail" v-show="data.beforeYesterday.loadingFail">
                <img src="/static/img/baseComponent/byDayTemplate/loading_fail.png" alt="加载失败"/>
              </div>
            </div>
            <div class="line"></div>
            <div class="footer">
              <el-button icon="el-icon-caret-left" size="mini" :disabled="data.beforeYesterday.pageIndex <= 1" type="primary" round @click="--data.beforeYesterday.pageIndex"></el-button>
              <el-button icon="el-icon-caret-right" size="mini" type="primary" round @click="nextPage"
                         :disabled="!data.beforeYesterday.moreFlag && data.beforeYesterday.pageIndex === data.beforeYesterday.pageTotal"
                         :loading="data.beforeYesterday.loadingFlag"></el-button>
            </div>
          </div>

        </el-tab-pane>
      </el-tabs>
    </div>
  </SpaceWindow>
</template>

<script>
    import SpaceWindow from "../baseComponent/SpaceWindow.vue"
    import Loading from "../component/Loading.vue"
    import { dateFormat } from "../../js/utils/dateUtils";

    export default {
        components: {SpaceWindow, Loading},
        name: "ByDayTemplate",
        props: {
            //标题
            title: {
                type: String,
                required: true
            },
            //api每页获取数量
            pageSize: {
                type: Number,
                default: 9
            },
            //api地址
            api: {
                type: String,
                required: true
            },
            //窗口body高度
            height: {type: String,
                required: false}
        },
        activated() {
            if (this.activate === "today") {
                this.nextPage();
            }
        },
        deactivated(){
            this.data.today.list = [];
            this.data.today.moreFlag = true;
            this.data.today.pageTotal = 0;
            this.data.today.pageIndex = 0;
            this.data.today.loadingFlag = false;
        },
        data() {
            let now = new Date();
            return {
                activate: "today",
                data: {
                    today: {
                        date: dateFormat(now),
                        list: [],
                        moreFlag: true,
                        pageTotal: 0,
                        pageIndex: 0,
                        loadingFlag: false,
                        loadingFail: false,
                    },
                    yesterday: {
                        date: dateFormat(new Date(now.getTime() - (24 * 60 * 60 * 1000))),
                        list: [],
                        moreFlag: true,
                        pageTotal: 0,
                        pageIndex: 0,
                        loadingFlag: false,
                        loadingFail: false,

                    },
                    beforeYesterday: {
                        date: dateFormat(new Date(now.getTime() - (24 * 60 * 60 * 1000 * 2))),
                        list: [],
                        moreFlag: true,
                        pageTotal: 0,
                        pageIndex: 0,
                        loadingFlag: false,
                        loadingFail: false,
                    }
                },
                nextFlag: true,
            }
        },
        methods: {
            nextPage() {
                let pageSize = this.pageSize;
                let data = this.data[this.activate];
                if (data.moreFlag && (data.pageIndex + 1) > data.pageTotal) {
                    data.loadingFlag = true;
                    this.$im.get(this.api, {
                        pageSize: pageSize,
                        pageIndex: data.pageIndex + 1,
                        date: data.date
                    }, true, (list) => {
                        data.loadingFail = false;
                        if (list.length < pageSize) {
                            data.moreFlag = false;
                            if (list.length === 0) {
                                return;
                            }
                        }
                        data.pageIndex++;
                        data.list.push(...list);
                        data.pageTotal++;
                    }, () => {
                        data.loadingFlag = false;
                    }, (msg) => {
                        data.loadingFail = true;
                    })
                } else {
                    data.pageIndex++;
                }
            },
            trigger() {
                let data = this.data[this.activate];
                if (data.pageIndex === 0 && data.moreFlag) {
                    this.nextPage();
                }
            }
        },
        computed: {
            //计算暴露数据
            todayExportList() {
                let data = this.data.today;
                let start = (data.pageIndex - 1) * this.pageSize;
                return data.list.slice(start, start + this.pageSize)
            },
            yesterdayExportList() {
                let data = this.data.yesterday;
                let start = (data.pageIndex - 1) * this.pageSize;
                return data.list.slice(start, start + this.pageSize)
            },
            beforeYesterdayExportList() {
                let data = this.data.beforeYesterday;
                let start = (data.pageIndex - 1) * this.pageSize;
                return data.list.slice(start, start + this.pageSize)
            },
        }
    }
</script>

<style scoped>
  .wrapper {
    padding: 0 15px;
  }

  .pane-wrapper {
    display: flex;
    flex-direction: column;
  }

  .empty,.fail {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }


  .line {
    border-bottom: 2px solid #eee;
    margin-bottom: 10px;
  }
  .footer {
    margin-bottom: 10px;
    text-align: right;
  }

</style>



// WEBPACK FOOTER //
// src/view/baseComponent/ByDayTemplate.vue